/**
 * jQuery ES Module Wrapper
 *
 * WordPress's jQuery is a global script, not an ES module.
 * This wrapper exports the global jQuery so it can be imported in ES modules.
 */

export default window.jQuery;
export const $ = window.jQuery;
